import axios, { AxiosError } from 'axios'
import { getCookieValue } from '@/utils/CookieUtil'

export interface ValidationError {
  [key: string]: any
}

export interface APIError {
  message: string | undefined
  status: number | undefined
  errors?: ValidationError
  raw: Error
}

const normalizeError = (error: AxiosError<any>): APIError => ({
  status: error.response && error.response.status,
  message: error.response && error.response.data && error.response.data.message,
  errors: error.response && error.response.data && error.response.data.errors,
  raw: error,
})

const baseURL: string = process.env.VUE_APP_API_HOST || 'https://api.gyym.jp'

const apiClient = axios.create({
  baseURL,
  timeout: 15 * 1000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN'),
  },
})

apiClient.interceptors.response.use(
  (res) => res.data,
  (error) => Promise.reject(normalizeError(error))
)

export const registerGlobalErrorHandler = (
  handler: (error: APIError) => Promise<any>
) => {
  apiClient.interceptors.response.use((res) => res, handler)
}

export default apiClient
